import { TrackAnalysis } from "../hooks/useHapticsEngine/types";

export class TrackAnalysisCache {
  private static STORAGE_KEY = "track_haptic_analysis_v1";

  public static async saveAnalysis(trackId: string, analysis: TrackAnalysis): Promise<void> {
    const stored = await this.getAllAnalyses();
    stored[trackId] = analysis;
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(stored));
  }

  public static async getAnalysis(trackId: string): Promise<TrackAnalysis | null> {
    const stored = await this.getAllAnalyses();
    return stored[trackId] || null;
  }

  private static async getAllAnalyses(): Promise<Record<string, TrackAnalysis>> {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    return stored ? JSON.parse(stored) : {};
  }

  public static async clearAnalysis(trackId?: string): Promise<void> {
    if (trackId) {
      const stored = await this.getAllAnalyses();
      delete stored[trackId];
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(stored));
    } else {
      localStorage.removeItem(this.STORAGE_KEY);
    }
  }
}
